export default "__VITE_ASSET__CLL2TOMh__"